import FeesService from "../components/DivorceCalculator/FeesService";
import { Settlement } from "../types/Products/EmploymentLaw/Settlement";
import dayjs from "dayjs";

const settlementCalculator = (settlement: Settlement, valueInDispute: number) => {
  const lastWorkDay = settlement.lastWorkDayCalculated ? dayjs(settlement.lastWorkDayCalculated) : dayjs();
  const employedSince = dayjs(settlement.employedSince);
  const workDurationInYears = Math.round(lastWorkDay.diff(employedSince, "years", true));
  const settlementValue = settlement.grossSalary * workDurationInYears * 0.5;
  const processCosts = FeesService.getFeeByValue(valueInDispute, 1.3, true);
  const hearingCosts = FeesService.getFeeByValue(valueInDispute, 1.2, true);
  const fullCosts = processCosts + hearingCosts + FeesService.getExpenses(true);
  const settlementCosts = FeesService.getFeeByValue(valueInDispute, 1, true);

  return {
    settlementValue,
    processCosts,
    hearingCosts,
    fullCosts,
    settlementCosts,
  };
};

export default settlementCalculator;
